<div
    class="so-date-picker__control"
    [class.so-date-picker__control--horizontal]="selectDisplay() === 'horizontal'"
    [class.so-date-picker__control--form-style]="formStyle()"
>
    @if (isFilter()) {
        <button
            type="button"
            class="filter-trigger"
            [class.filter-trigger--active]="isOpen()"
            [class.filter-trigger--has-value]="!!selectedText()"
            [disabled]="selectDisabled()"
            role="combobox"
            [attr.aria-expanded]="isOpen()"
            [attr.aria-disabled]="selectDisabled()"
            aria-haspopup="dialog"
            (click)="onTriggerClick($event)"
            (keydown)="onTriggerKeyDown($event)"
        >
            <span class="filter-trigger__text">{{ selectedText() || selectLabel() || 'Seleccionar' }}</span>
            <svg class="filter-trigger__chevron" viewBox="0 0 24 24" fill="none">
                <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    } @else {
        <div class="select__form" [class.select__form--horizontal]="selectDisplay() === 'horizontal'">
            @if (selectLabel() && selectDisplay() === 'horizontal' && !formStyle()) {
                <label class="inline-label">{{ selectLabel() }}@if (effectiveRequired()) { <span class="required-mark">*</span>}</label>
            }
            @if (selectLabel() && (selectDisplay() !== 'horizontal' || formStyle())) {
                <label class="select-label">{{ selectLabel() }}@if (effectiveRequired()) { <span class="required-mark">*</span>}</label>
            }
            <div class="select-container">
                <button
                    type="button"
                    class="select-trigger date-trigger"
                    [class.date-trigger--open]="isOpen()"
                    [disabled]="selectDisabled()"
                    [style.--so-select-height.px]="selectHeight()"
                    role="combobox"
                    [attr.aria-expanded]="isOpen()"
                    [attr.aria-disabled]="selectDisabled()"
                    aria-haspopup="dialog"
                    (click)="onTriggerClick($event)"
                    (keydown)="onTriggerKeyDown($event)"
                >
                    @if (!selectedText()) {
                        <span class="date-trigger__placeholder">{{ placeholder() }}</span>
                    }
                    @if (selectedText()) {
                        <span class="date-trigger__value text-truncate">{{ selectedText() }}</span>
                    }
                    <svg class="date-trigger__chevron" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    }
</div>

@if (isOpen()) {
    <div class="so-date-picker__overlay">
        <div class="so-date-picker__backdrop" (click)="onClose()"></div>
        <div
            class="so-date-picker"
            [class.so-date-picker--filter]="isFilter()"
            (click)="$event.stopPropagation()"
            [style.top.px]="position()?.top ?? 0"
            [style.left.px]="position()?.left ?? 0"
            [style.minWidth.px]="isFilter() ? (position()?.width ?? null) : null"
            #overlayElement
            cdkTrapFocus
        >
            @if (isFilter()) {
                <div class="filter-panel-header">{{ selectLabel() || 'Fecha' }}</div>
            }
            <div class="so-date-picker__body">
                @if (!isFilter() && overlayTitle()) {
                    <span class="so-text-2-bold so-primary">{{ overlayTitle() }}</span>
                }
                <div class="so-date-picker__content">
                    <so-calendar-ui
                        [selectionMode]="'single'"
                        [selectedDate]="selectedDate()"
                        [minDate]="minDate()"
                        [maxDate]="maxDate()"
                        (onChangeDate)="onDateSelected($event)"
                    ></so-calendar-ui>
                </div>
            </div>
        </div>
    </div>
}
